export default __webpack_public_path__ + "static/media/edot_cloudxier1.ae417e77.png";